import axios from 'axios';

const API_URL = process.env.VUE_APP_BACKEND_BASE_URL + '/rest/auth/';

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'login', {
                username: user.username,
                password: user.password,
                secret: user.secret
            })
            .then(response => {
                // console.log(response);
                if (response.data.response.token) {
                    localStorage.setItem('user', JSON.stringify(response.data.response));
                }

                return response.data.response;
            });
    }

    logout() {
        localStorage.removeItem('user');
    }

    register(user) {
        return axios.post(API_URL + 'signup', {
            login: user.username,
            email: user.email,
            password: user.password
        });
    }
}

export default new AuthService();
